import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Knowledgebase } from "../../Constant";
import KnowledgebaseHelp from "./KnowledgebaseHelp";
import Articals from "./Articals";
import CategoryData from "./CategoryData";
import FeaturesTutorial from "./FeaturesTutorial";
import ArticalAndVideo from "./ArticalVideo";

const KnowledgebaseContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Knowledgebase} parent={Knowledgebase} title={Knowledgebase} />
      <Container fluid>
        <Row>
          <KnowledgebaseHelp />
          <Articals/>
          <CategoryData/>
          <FeaturesTutorial/>
          <ArticalAndVideo/>
        </Row>
      </Container>
    </>
  );
};

export default KnowledgebaseContainer;
